import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Artists from "./pages/Artists";
import Piercing from "./pages/Piercing";
import Pricing from "./pages/Pricing";
import Gallery from "./pages/Gallery";
import Products from "./pages/Products";
import Contact from "./pages/Contact";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => window.__lenis?.scrollTo(el, { offset: -80 }), 120);
        return;
      }
    }
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="noise-overlay" />
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/muveszek" element={<Artists />} />
            <Route path="/piercing" element={<Piercing />} />
            <Route path="/arak" element={<Pricing />} />
            <Route path="/galeria" element={<Gallery />} />
            <Route path="/termekek" element={<Products />} />
            <Route path="/kapcsolat" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-center" toastOptions={{ style: { background: "#151518", border: "1px solid #232327", color: "#F5F5F7" } }} />
    </div>
  );
}

export default App;
